export default {
  state: {
    iconsModals: {
      comment: false,
      info: false,
      activity: false,
      filter: false,
    },
    isReload: false
  },
  mutations: {
    setIconsModals(state, { modal, value }) {
      state.iconsModals[modal] = value;
    },
    setIsReload(state, value) {
      state.isReload = value
    }
  },
};
